/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../AppContext';
import { GUESS_COUNT } from '../consts';
import GameRow from './GameRow';

export const EMPTY_ROW = [' ', ' ', ' ', ' ', ' '];

const GameBox = ({ id, className = '' }) => {
  const [{ guesses, input, [id]: word, shake, [`${id}Done`]: wordDone }] = useContext(AppContext);

  const [rows, setRows] = useState([]);

  useEffect(() => {
    const guessesLength = guesses.length;
    const emptyRowCount = GUESS_COUNT - 1 - Number(guessesLength);
    if (emptyRowCount <= GUESS_COUNT && emptyRowCount >= 0) {
      const newRows = [input, ...new Array(emptyRowCount).fill([' ', ' ', ' ', ' ', ' '])];
      setRows(newRows);
    }
  }, [guesses, input]);

  const stopTyping = guesses.length === GUESS_COUNT || wordDone;

  let guessesToShow = guesses;
  if (wordDone) {
    let correctWordIndex = GUESS_COUNT;
    guesses.forEach((guess, i) => {
      if (guess.join('') === word) {
        correctWordIndex = i;
      }
    });
    guessesToShow = guesses.slice(0, correctWordIndex + 1);
  }

  return (
    <div className={`w-[calc(50%-0.25rem)] md:mx-2 relative ${className}`}>
      {stopTyping && !wordDone && getNotification(word)}
      {!wordDone && shake && getNotification('Yanlış Kelime')}
      {guessesToShow.map((_, i) => {
        return <GameRow key={`g${i}`} isGuess word={word} input={guessesToShow[i]} />;
      })}
      {stopTyping
        ? new Array(GUESS_COUNT - guessesToShow.length).fill([]).map((_, i) => {
            return <GameRow key={i} word={word} input={EMPTY_ROW} />;
          })
        : rows.map((_, i) => {
            return <GameRow key={i} word={word} input={rows[i]} />;
          })}
    </div>
  );

  function getNotification(text) {
    return (
      <div className='absolute bottom-10 left-1/2'>
        <div className='relative -left-1/2 font-bold bg-white/80 p-2 rounded'>{text}</div>
      </div>
    );
  }
};

export default GameBox;
